export function flattenTags(tags: Record<string, number>) {
  const outTags = Object.keys(tags)
    .map((key) => [key, tags[key]] as [string, number])
    .sort((a, b) => b[1] - a[1])
    .map((val) => val[0]);

  return outTags;
}
